import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-832395d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table" }
const _hoisted_2 = ["onClick"]

import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { queryDeviceFactoryTestPage } from '@/api'
import { CODE_ENUM, PAGE_SIZES } from '@/common'
import moment from 'moment'
import FactoryTestTableItem from './factory-testing-item.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'factory-testing',
  setup(__props) {

const formatTime = (value: any) => {
  return value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : '-'
}

const tableData = ref([])
const tableLoading = ref(false)

const $route = useRoute()

const deviceId = $route.query.deviceId || ''

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const fetchList = async () => {
  const res: any = await queryDeviceFactoryTestPage({
    ...pageParams.value,
    deviceId,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res.data?.records || []
    total.value = res?.data?.total || 0
  }
}

onMounted(() => {
  fetchList()
})

const itemConf = ref({
  visible: false,
  data: [],
  title: '',
})

const handleItemRecord = ({ infoVOList, itemName }: any) => {
  itemConf.value = {
    visible: true,
    data: infoVOList || [],
    title: itemName,
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        class: "ws_common_table ws_mt24"
      }, {
        empty: _withCtx(() => [
          _createVNode(_component_el_empty, { description: "暂无数据" })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "测试项目",
            prop: "itemName",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "测试结果",
            prop: "testStatusValue",
            "show-overflow-tooltip": "",
            width: "300"
          }, {
            default: _withCtx((scoped) => [
              (scoped.row.testStatus)
                ? (_openBlock(), _createBlock(_component_el_tag, { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scoped.row.testStatusValue), 1)
                    ]),
                    _: 2
                  }, 1024))
                : (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scoped.row.testStatusValue), 1)
                    ]),
                    _: 2
                  }, 1024))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "时间",
            prop: "createDate",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scoped) => [
              _createTextVNode(_toDisplayString(formatTime(scoped.row.createDate)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "详情",
            width: "200"
          }, {
            default: _withCtx((scoped) => [
              _createElementVNode("a", {
                onClick: ($event: any) => (handleItemRecord(scoped.row)),
                style: {"color":"#1d58d4"}
              }, "查询", 8, _hoisted_2)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, tableLoading.value]
      ]),
      _createVNode(_component_el_pagination, {
        class: "ws_mt50",
        "current-page": pageParams.value.curPage,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((pageParams.value.curPage) = $event)),
        "page-size": pageParams.value.pageSize,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageParams.value.pageSize) = $event)),
        "page-sizes": _unref(PAGE_SIZES),
        layout: "->, total, sizes, prev, pager, next, jumper ",
        total: total.value,
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
    ]),
    _createVNode(FactoryTestTableItem, {
      visible: itemConf.value.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((itemConf.value.visible) = $event)),
      data: itemConf.value.data,
      title: itemConf.value.title
    }, null, 8, ["visible", "data", "title"])
  ], 64))
}
}

})